import {connect, useSelector} from "react-redux";
import React from "react";
import {useFindAccessInAccessList} from "../../../constants/constant/accessProcess";
import {getCellValue} from "../../../utils/utils";
import Tooltip from "../general/tooltip";
import Icon from "../general/icon";
import {general} from "../../../store/action";

type PrescriptionReferralTableRowItemProps = {
    item: any;
    handleShowModal: any;
}

const PrescriptionReferralTableRowItem = ({
    item,
    handleShowModal
}: PrescriptionReferralTableRowItemProps) => {

    const isProvider = useSelector((state: any) => state.general.userDataReducer.isProvider);
    const {findAccessInAccessList} = useFindAccessInAccessList();

    return (
        <tr>
            <td>{getCellValue(item?.memberFulName)}</td>
            <td>{getCellValue(item?.serviceName)}</td>
            <td>{getCellValue(item?.trackingCode)}</td>
            <td>{getCellValue(item?.creationDate)}</td>
            <td>
                <div className="d-flex justify-content-center align-items-center">
                    <Tooltip alt={"مشاهده"} className="tooltip-pre-line">
                        <span
                            onClick={() =>
                                handleShowModal('ihioPrescriptionReferralInfoModal', {citizenItemId: item?.citizenItemId, nationalCode: item?.memberNN, samadCode: item?.samadCode})
                            }
                            className={`d-flex mx-2 font-20 cur-pointer text-hover`}
                        >
                          <Icon name='eye'/>
                        </span>
                    </Tooltip>
                </div>
            </td>
        </tr>
    )
}

const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PrescriptionReferralTableRowItem);
